import { SECTION_TYPE } from "dt-components/lib/es/components/molecules/landingPage/enum";
import {
  IComponentDetail,
  IDataSection,
  IMetaData,
} from "dt-components/lib/es/components/molecules/landingPage/types";
import { appData, PB_REPLACE_CONSTANTS } from "src/constants";
import { IAppDataState } from "src/types";


export function replaceAll(
  text: string,
  search: string,
  replace: string
): string {
  return text.split(search).join(replace);
}

export function getStaticBaseUrl(appData: IAppDataState): string {
    let baseUrl = appData.IMAGE_BASE_URL;
    if (baseUrl.lastIndexOf('/') !== -1) {
      baseUrl = baseUrl.substr(0, baseUrl.lastIndexOf('/'));
    }
  
    return baseUrl;
  }

function isMetaData(
  data: IMetaData | IComponentDetail
): data is IComponentDetail {
  return (data as IComponentDetail).count !== undefined;
}

export function replaceAllIfExist(
  text: string,
  search: string,
  replace: string
): string {
  if (typeof text !== "string") {
    return text;
  }
  const isExist = text.split(search);

  return isExist.length > 1 ? text.split(search).join(replace) : text;
}

export function processFullNamePlaceholder(
  item: IMetaData | IComponentDetail,
  defaultPlaceholder: string,
  fullName?: string
) {
  Object.keys(item).forEach((k) => {
    if (typeof item[k] === "string") {
      if (fullName) {
        item[k] = replaceAllIfExist(
          item[k],
          PB_REPLACE_CONSTANTS.LOGGED_IN_USER_NAME_PLACEHOLDER,
          fullName
        );
      } else {
        item[k] = replaceAllIfExist(
          item[k],
          PB_REPLACE_CONSTANTS.LOGGED_IN_USER_NAME_PLACEHOLDER,
          defaultPlaceholder
        );
      }
    }
    if (typeof item[k] === "object") {
      item[k] = processFullNamePlaceholder(
        item[k],
        defaultPlaceholder,
        fullName
      );
    }
  });

  return item;
}

// tslint:disable-next-line: cognitive-complexity
export function parseLandingPageStaticContent(
  data: IDataSection[],
  appData: IAppDataState,
  replaceText = "",
  fullName = "",
  isCampaignSnippetLoader = false,
  loaderText = ""
): IDataSection[] {
  if (!data) {
    return [];
  }
  const newData: IDataSection[] = [];
  data.forEach((sectionData: IDataSection) => {
    if (sectionData.type === "TEMPLATE" && sectionData.templateData) {
      const templateData: IDataSection[] = [];
      sectionData.templateData.forEach((tempSectionData: IDataSection) => {
        const metaData: IMetaData[] = [];
        if (tempSectionData.metaData && tempSectionData.metaData.length > 0) {
          tempSectionData.metaData.forEach((item) => {
            const newSectionData = processFullNamePlaceholder(
              item,
              replaceText,
              fullName
            );
            if (!isMetaData(newSectionData)) {
              if (item.imageUrl) {
                newSectionData.imageUrl = getAbsoluteUrl(
                  item.imageUrl,
                  appData
                );
              }
              if (item.mobileImageUrl) {
                newSectionData.mobileImageUrl = getAbsoluteUrl(
                  item.mobileImageUrl,
                  appData
                );
              }
              const customHtmlTypes = [
                "CUSTOM_HTML",
                "CUSTOM_HTML_POP_UP",
                "RICH_TEXT_POP_UP",
              ];
              if (customHtmlTypes.includes(tempSectionData.type)) {
                let value = item.value;
                // value = replaceAll(
                //   value,
                //   PB_REPLACE_CONSTANTS.IMAGE_BASE_URL,
                //   `${getStaticBaseUrl(appData)}/resize-image?f=`
                // );
                value = replaceStaticBaseUrl(value);
                newSectionData.value = value;
              }
              metaData.push(newSectionData);
            }
          });
        }
        tempSectionData.metaData = metaData;
        templateData.push(tempSectionData);
      });
      newData.push({ ...sectionData, templateData });
    } else {
      const metaData: IMetaData[] = [];
      const componentsDetail: IComponentDetail[] = [];
      if (
        sectionData.type === SECTION_TYPE.CAMPAIGN_PLACE_HOLDER ||
        sectionData.type === SECTION_TYPE.COMPONENT_NAVIGATION
      ) {
        sectionData.customSpacing = isCampaignSnippetLoader; // used to show loader in this case
        sectionData.title = loaderText;
        sectionData?.componentsDetail?.forEach((item) => {
          const newSectionData = processFullNamePlaceholder(
            item,
            replaceText,
            fullName
          );
          if (isMetaData(newSectionData)) {
            componentsDetail.push(newSectionData);
          }
        });
      }
      if (sectionData.metaData && sectionData.metaData.length > 0) {
        sectionData.metaData.forEach((item) => {
          const newSectionData = processFullNamePlaceholder(
            item,
            replaceText,
            fullName
          );
          if (!isMetaData(newSectionData)) {
            if (item.imageUrl) {
              newSectionData.imageUrl = getAbsoluteUrl(item.imageUrl, appData);
            }
            if (item.mobileImageUrl) {
              newSectionData.mobileImageUrl = getAbsoluteUrl(
                item.mobileImageUrl,
                appData
              );
            }
            const customHtmlTypes = [
              "CUSTOM_HTML",
              "CUSTOM_HTML_POP_UP",
              "RICH_TEXT_POP_UP",
            ];
            if (customHtmlTypes.includes(sectionData.type)) {
              let value = item.value;
              // value = replaceAll(
              //   value,
              //   PB_REPLACE_CONSTANTS.IMAGE_BASE_URL,
              //   `${getStaticBaseUrl(appData)}/resize-image?f=`
              // );
              value = replaceStaticBaseUrl(value);
              newSectionData.value = value;
            }
            metaData.push(newSectionData);
          }
        });
      }
      // eslint-disable-next-line @typescript-eslint/no-unused-expressions
      componentsDetail?.length
        ? newData.push({ ...sectionData, metaData, componentsDetail })
        : newData.push({ ...sectionData, metaData });
    }
  });

  return newData;
}

function replaceStaticBaseUrl(content: string) {
  return content.replace(
    /\$\{STATIC_BASE_URL\}([^ ]+\.(gif|[^. ]+))/g,
    (__match, __url, __ext) => {
      const abc = __ext === "gif" ? `${appData.IMAGE_BASE_URL}${__url}` : `${appData.IMAGE_BASE_URL}resize-image?f=${__url}`;

      return abc;
    }
  );
}

export function getAbsoluteUrl(
  imageUrl: string,
  appData: IAppDataState
): string {
  if (!imageUrl) {
    return imageUrl;
  }
  if (imageUrl.indexOf("http://") === 0 || imageUrl.indexOf("https://") === 0) {
    return imageUrl;
  }
  let baseUrl = appData.IMAGE_BASE_URL;
  if (baseUrl.lastIndexOf("/") !== -1) {
    baseUrl = baseUrl.substr(0, baseUrl.lastIndexOf("/"));
  }

  return `${baseUrl}/resize-image?f=${imageUrl}`;
}
